

export const decodeFile = async (typeFile, response,fileName=null) =>{
    const responseData = response?.data || response;
    const responseFileName = fileName ? fileName : response?.name;
    const byteString =  window.atob(responseData.split(",")[1])
    const mimeString = responseData
      .split(",")[0]
      .split(":")[1]
      .split(";")[0];
  
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
  
    const dataBlob = new Blob([ab], { type: mimeString });
  
    if ( window?.navigator?.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(
        dataBlob,
        `${responseFileName}.${typeFile}`
      );
      return;
    }
  
    const url = window.URL.createObjectURL(dataBlob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${responseFileName}.${typeFile}`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  
  }